import React from "react";
import { Box } from "@cloudscape-design/components";
import Icon from "@cloudscape-design/components/icon";
import SectionHeader from "../../common/SectionHeader";
import ProductLinkList from "../../common/ProductLinkList";
import { DATA_PRODUCTS } from "../../../config/data-products";

const AccessDataSection: React.FC = () => {
  return (
    <Box>
      <SectionHeader
        title="Access Data"
        variant="h2"
        icon={<Icon name="transcript" />}
        useGradient={true}
      />
      <ProductLinkList items={DATA_PRODUCTS} defaultIcon="anchor-link" />
    </Box>
  );
};

export default AccessDataSection;
